"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AbstractLight = void 0;
const viewer_shared_services_1 = require("@shapediver/viewer.shared.services");
const viewer_shared_node_tree_1 = require("@shapediver/viewer.shared.node-tree");
const tsyringe_1 = require("tsyringe");
class AbstractLight extends viewer_shared_node_tree_1.AbstractTreeNodeData {
    // #endregion Properties (6)
    // #region Constructors (1)
    constructor(properties) {
        super(properties.id);
        this._useNodeData = false;
        this._uuidGenerator = tsyringe_1.container.resolve(viewer_shared_services_1.UuidGenerator);
        this._color = properties.color;
        this._intensity = properties.intensity;
        this._type = properties.type;
        this._name = properties.name;
        this._order = properties.order;
    }
    // #endregion Constructors (1)
    // #region Public Accessors (9)
    get color() {
        return this._color;
    }
    set color(value) {
        this._color = value;
        this.updateVersion();
    }
    get intensity() {
        return this._intensity;
    }
    set intensity(value) {
        this._intensity = value;
        this.updateVersion();
    }
    get name() {
        return this._name;
    }
    set name(value) {
        this._name = value;
        this.updateVersion();
    }
    get order() {
        return this._order;
    }
    set order(value) {
        this._order = value;
        this.updateVersion();
    }
    get type() {
        return this._type;
    }
    set useNodeData(value) {
        this._useNodeData = value;
    }
    get useNodeData() {
        return this._useNodeData;
    }
}
exports.AbstractLight = AbstractLight;
//# sourceMappingURL=AbstractLight.js.map